import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IItemDropdown } from 'src/app/core/interfaces/dropdown.models';
import { AsesorDialogService } from './asesor-dialog.service';
import {Asesor, AsesorRequestPaginated} from "./asesor-dialog.model";
import { MessageConstants } from 'src/app/core/constants/message';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-product-dialog',
  templateUrl: './asesor-dialog.component.html',
  styleUrls: ['./asesor-dialog.component.css']
})
export class AsesorDialogComponent implements OnInit {
  isFirstLoad: boolean = true;
  totalRows: number = 0;
  lsAsesor: Asesor[] = [];
  codigosMessage: any;
  mensajesMessage: any;
  loading: boolean = false;

  readonly: boolean = false;

  constructor(private AsesorDialogService: AsesorDialogService
    , public ref: DynamicDialogRef
    , public config: DynamicDialogConfig
    , private secureStorageService: SecureStorageService
    , private cdr: ChangeDetectorRef
  ){
      this.readonly = config.data.readonly
  }

  ngOnInit(): void {
    this.loading = true;
    const companyId = this.secureStorageService.getData("CompanyId");
    let AsesorReq: AsesorRequestPaginated = {
      CompanyId: companyId,
      Nombre:'',
      Codigo:''
    };
    this.getAsesorData(AsesorReq);
  }

  getAsesorData(request: AsesorRequestPaginated){

    [this.codigosMessage, this.mensajesMessage] = MessageConstants;
    this.AsesorDialogService.getPaginated(request)
      .subscribe(
        {
          next: (data) => {
            let dataTmp = data;
            if(dataTmp) {
              this.lsAsesor = dataTmp;
            }
            this.cdr.detectChanges();
          },
          error: (error) => {
            if(error){
              console.log(error);
            }
            this.cdr.detectChanges();
          },
          complete: () => {
            this.loading = false;
            this.cdr.detectChanges();
          }
        }
      );
  }

  onRowDblClick(event: any, dataSelected: any){

    if(this.readonly)return;
    
    if(dataSelected){
      let _description = ((dataSelected.Nombre) ? dataSelected.Nombre : "" ) ;
      let itemDropdown: IItemDropdown = {
        code: dataSelected.Id,
        description: _description,
        dataSerialize: JSON.stringify(dataSelected)
      }
      this.ref.close(itemDropdown);
    }

  }

}
